module.exports = __webpack_public_path__ + "static/media/petitioner_basic.ab5e84ac.pdf";